module.exports = __webpack_public_path__ + "40883959693b480a4a45ce2ac96ee8ae.png";